import {Injectable} from '@angular/core';
import {ApModalResult, ApModalService} from 'webcommon/core-ui';
import { IColumnPk } from 'webcommon/shared';
import { FcItemModalContext } from '../../models/FcItemModalContext';

import {FcItemConfig} from '../fc-item-config';

@Injectable({
  providedIn: 'root',
})
export class FcItemModalService{
  constructor(
    private apModalService: ApModalService,
    private fcItemConfig: FcItemConfig,
  ) { }

  openModal(
    fcModalItemContext: FcItemModalContext
  ): Promise<ApModalResult<IColumnPk>> {
    const initialState = {
      fcModalItemContext
    };

    const findControlModalType = this.fcItemConfig.fcItemModalById.get(fcModalItemContext.findControlId) ||
    this.fcItemConfig.defaultItemModal;

    const p = this.apModalService.showComponentModal(findControlModalType, {
      class: 'emds-modal-medium',
      ignoreBackdropClick: true,
      initialState,
    });

    return p;
  }
}
